import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';
import StepProgress from '../../../../components/StepProgress';
import steps from '../../../../utils/steps.json';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

function AguardarAnalise() {
    const successTitle = 'Você trocou dados de beneficiário. Agora é com a gente!';
    const successMessage = [
        [
            <br />,
            'Nos próximos 3 dias úteis vamos analisar as novas informações para fazer a troca do plano.',
            <br />,
            'Acompanhe o status da sua solicitação pelo ',
            <Link to="/movimentacao_cadastral/movimentacoes_pendentes">
                <u>Movimentações pendentes.</u>
            </Link>,
        ],
    ];

    const history = useHistory();

    return (
        <PageContainer>
            <StepProgress steps={steps.alterarBeneficiario} activeStep={3} />

            <Alert type={3} title={successTitle} message={successMessage} />

            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.push('/')}>
                    Acessar home
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    onClick={() => history.push('/movimentacao_cadastral/selecionar_trocar_plano')}
                >
                    Trocar novo plano
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default AguardarAnalise;
